/**
 * @generated SignedSource<<f3429159edb61f9a8534a37586251d37>>
 * @relayHash b9f3cbcb425a8be7d30e3cf5db92f62d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1da2ae2f80c8177b5dcd3d56ab0591dd8cb49de78696c7ca562a6a372a6f3d88

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HomeAssignedListQuery$variables = {
  first?: number | null;
  jiraIssueQuery: string;
  pullRequestQuery: string;
  queryContext: string;
  townsquareQuery: string;
};
export type HomeAssignedListQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HomeAssignedList">;
};
export type HomeAssignedListQuery = {
  response: HomeAssignedListQuery$data;
  variables: HomeAssignedListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jiraIssueQuery"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pullRequestQuery"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryContext"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "townsquareQuery"
},
v5 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v6 = {
  "kind": "Variable",
  "name": "queryContext",
  "variableName": "queryContext"
},
v7 = {
  "kind": "ScalarField",
  "name": "key"
},
v8 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v9 = {
  "kind": "ScalarField",
  "name": "url"
},
v10 = {
  "kind": "ScalarField",
  "name": "value"
},
v11 = [
  (v10/*: any*/)
],
v12 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v13 = {
  "kind": "ScalarField",
  "name": "id"
},
v14 = [
  {
    "kind": "ScalarField",
    "name": "creationDate"
  },
  {
    "kind": "ScalarField",
    "name": "editDate"
  },
  (v13/*: any*/)
],
v15 = {
  "kind": "ScalarField",
  "name": "name"
},
v16 = {
  "kind": "ScalarField",
  "name": "iconData"
},
v17 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v18 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v19 = {
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v15/*: any*/),
    (v17/*: any*/),
    (v18/*: any*/),
    (v13/*: any*/)
  ]
},
v20 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v21 = {
  "kind": "ScalarField",
  "name": "picture"
},
v22 = [
  (v13/*: any*/)
],
v23 = {
  "kind": "InlineFragment",
  "selections": (v22/*: any*/),
  "type": "AppUser"
},
v24 = {
  "kind": "InlineFragment",
  "selections": (v22/*: any*/),
  "type": "CustomerUser"
},
v25 = [
  {
    "concreteType": "ThirdPartyUser",
    "kind": "LinkedField",
    "name": "thirdPartyUser",
    "plural": false,
    "selections": [
      (v15/*: any*/),
      (v21/*: any*/),
      (v13/*: any*/)
    ]
  },
  {
    "args": (v12/*: any*/),
    "concreteType": "GraphStoreSimplifiedUserLinkedThirdPartyUserInverseConnection",
    "kind": "LinkedField",
    "name": "linkedUsers",
    "plural": false,
    "selections": [
      {
        "concreteType": "GraphStoreSimplifiedUserLinkedThirdPartyUserInverseEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v15/*: any*/),
                  (v21/*: any*/),
                  (v18/*: any*/),
                  (v17/*: any*/),
                  (v13/*: any*/)
                ],
                "type": "AtlassianAccountUser"
              },
              (v23/*: any*/),
              (v24/*: any*/)
            ]
          },
          (v13/*: any*/)
        ]
      }
    ],
    "storageKey": "linkedUsers(first:1)"
  }
],
v26 = [
  {
    "concreteType": "GraphStoreCypherQueryV2Edge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "GraphStoreCypherQueryV2Node",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "concreteType": "GraphStoreCypherQueryV2Column",
            "kind": "LinkedField",
            "name": "columns",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              {
                "kind": "LinkedField",
                "name": "value",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "data",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v9/*: any*/),
                              {
                                "alias": "goalName",
                                "kind": "ScalarField",
                                "name": "name"
                              },
                              {
                                "alias": "goalState",
                                "concreteType": "TownsquareGoalState",
                                "kind": "LinkedField",
                                "name": "state",
                                "plural": false,
                                "selections": (v11/*: any*/)
                              },
                              {
                                "alias": "goalCreationDate",
                                "kind": "ScalarField",
                                "name": "creationDate"
                              },
                              {
                                "alias": "goalUpdates",
                                "args": (v12/*: any*/),
                                "concreteType": "TownsquareGoalUpdateConnection",
                                "kind": "LinkedField",
                                "name": "updates",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalUpdateEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareGoalUpdate",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": (v14/*: any*/)
                                      }
                                    ]
                                  }
                                ],
                                "storageKey": "updates(first:1)"
                              },
                              (v13/*: any*/),
                              (v15/*: any*/),
                              {
                                "alias": "goalStatus",
                                "concreteType": "TownsquareStatus",
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "score"
                                  }
                                ]
                              },
                              (v16/*: any*/),
                              (v19/*: any*/)
                            ],
                            "type": "TownsquareGoal"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v9/*: any*/),
                              {
                                "alias": "projectName",
                                "kind": "ScalarField",
                                "name": "name"
                              },
                              {
                                "alias": "projectState",
                                "concreteType": "TownsquareProjectState",
                                "kind": "LinkedField",
                                "name": "state",
                                "plural": false,
                                "selections": (v11/*: any*/)
                              },
                              {
                                "alias": "projectCreationDate",
                                "kind": "ScalarField",
                                "name": "creationDate"
                              },
                              {
                                "alias": "projectUpdates",
                                "args": (v12/*: any*/),
                                "concreteType": "TownsquareProjectUpdateConnection",
                                "kind": "LinkedField",
                                "name": "updates",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareProjectUpdateEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareProjectUpdate",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": (v14/*: any*/)
                                      }
                                    ]
                                  }
                                ],
                                "storageKey": "updates(first:1)"
                              },
                              (v13/*: any*/),
                              (v15/*: any*/),
                              (v16/*: any*/),
                              (v19/*: any*/)
                            ],
                            "type": "TownsquareProject"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v20/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "summary"
                              },
                              {
                                "concreteType": "JiraStatusField",
                                "kind": "LinkedField",
                                "name": "statusField",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraStatus",
                                    "kind": "LinkedField",
                                    "name": "status",
                                    "plural": false,
                                    "selections": [
                                      (v15/*: any*/),
                                      {
                                        "concreteType": "JiraStatusCategory",
                                        "kind": "LinkedField",
                                        "name": "statusCategory",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "mercuryName"
                                          },
                                          (v13/*: any*/)
                                        ]
                                      },
                                      (v13/*: any*/)
                                    ]
                                  },
                                  (v13/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "JiraDateTimePickerField",
                                "kind": "LinkedField",
                                "name": "updatedField",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "dateTime"
                                  },
                                  (v13/*: any*/)
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "name": "assignee",
                                "plural": false,
                                "selections": [
                                  (v8/*: any*/),
                                  (v18/*: any*/),
                                  (v13/*: any*/)
                                ]
                              },
                              (v7/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "dueDate"
                              },
                              (v13/*: any*/),
                              {
                                "concreteType": "JiraIssueTypeField",
                                "kind": "LinkedField",
                                "name": "issueTypeField",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueType",
                                    "kind": "LinkedField",
                                    "name": "issueType",
                                    "plural": false,
                                    "selections": [
                                      (v15/*: any*/),
                                      {
                                        "concreteType": "JiraAvatar",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "small"
                                          }
                                        ]
                                      },
                                      (v13/*: any*/)
                                    ]
                                  },
                                  (v13/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "JiraProjectField",
                                "kind": "LinkedField",
                                "name": "projectField",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "project",
                                    "plural": false,
                                    "selections": [
                                      (v15/*: any*/),
                                      (v20/*: any*/),
                                      (v13/*: any*/)
                                    ]
                                  },
                                  (v13/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraIssue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v9/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "displayName"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "status"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "lastUpdate"
                              },
                              {
                                "alias": "allReviewers",
                                "concreteType": "ExternalReviewer",
                                "kind": "LinkedField",
                                "name": "reviewers",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "ExternalUser",
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "userId"
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "connectorType"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "thirdPartyId"
                              },
                              {
                                "concreteType": "ExternalUser",
                                "kind": "LinkedField",
                                "name": "author",
                                "plural": false,
                                "selections": (v25/*: any*/)
                              },
                              {
                                "concreteType": "ExternalReviewer",
                                "kind": "LinkedField",
                                "name": "reviewers",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "approvalStatus"
                                  },
                                  {
                                    "concreteType": "ExternalUser",
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": (v25/*: any*/)
                                  }
                                ]
                              },
                              {
                                "concreteType": "ExternalProvider",
                                "kind": "LinkedField",
                                "name": "provider",
                                "plural": false,
                                "selections": [
                                  (v15/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "providerId"
                                  }
                                ]
                              }
                            ],
                            "type": "ExternalPullRequest"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v22/*: any*/),
                            "type": "Node",
                            "abstractKey": "__isNode"
                          },
                          (v23/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v22/*: any*/),
                            "type": "AtlassianAccountUser"
                          },
                          (v24/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v22/*: any*/),
                            "type": "DevOpsFeatureFlag"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v22/*: any*/),
                            "type": "DevOpsOperationsComponentDetails"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v22/*: any*/),
                            "type": "DevOpsOperationsIncidentDetails"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v22/*: any*/),
                            "type": "DevOpsOperationsPostIncidentReviewDetails"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v22/*: any*/),
                            "type": "DevOpsProjectDetails"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v22/*: any*/),
                            "type": "DevOpsPullRequestDetails"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v22/*: any*/),
                            "type": "DevOpsRepository"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v22/*: any*/),
                            "type": "DevOpsSecurityVulnerabilityDetails"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v22/*: any*/),
                            "type": "JiraAutodevJob"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v22/*: any*/),
                            "type": "JiraConfluenceRemoteIssueLink"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v22/*: any*/),
                            "type": "JiraCustomRemoteIssueLink"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v22/*: any*/),
                            "type": "JiraIssueRemoteIssueLink"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v22/*: any*/),
                            "type": "JiraWebRemoteIssueLink"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v22/*: any*/),
                            "type": "TeamCustomFieldValue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v22/*: any*/),
                            "type": "TeamType"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v22/*: any*/),
                            "type": "ThirdPartyUser"
                          }
                        ]
                      },
                      (v13/*: any*/)
                    ],
                    "type": "GraphStoreCypherQueryV2AriNode"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "GraphStoreCypherQueryV2TimestampObject"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": "stringValue",
                        "kind": "ScalarField",
                        "name": "value"
                      }
                    ],
                    "type": "GraphStoreCypherQueryV2StringObject"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "HomeAssignedListQuery",
    "selections": [
      {
        "args": [
          (v5/*: any*/),
          {
            "kind": "Variable",
            "name": "jiraIssueQuery",
            "variableName": "jiraIssueQuery"
          },
          {
            "kind": "Variable",
            "name": "pullRequestQuery",
            "variableName": "pullRequestQuery"
          },
          (v6/*: any*/),
          {
            "kind": "Variable",
            "name": "townsquareQuery",
            "variableName": "townsquareQuery"
          }
        ],
        "kind": "FragmentSpread",
        "name": "HomeAssignedList"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "HomeAssignedListQuery",
    "selections": [
      {
        "concreteType": "GraphStore",
        "kind": "LinkedField",
        "name": "graphStore",
        "plural": false,
        "selections": [
          {
            "alias": "townsquare",
            "args": [
              (v5/*: any*/),
              {
                "kind": "Variable",
                "name": "query",
                "variableName": "townsquareQuery"
              },
              (v6/*: any*/)
            ],
            "concreteType": "GraphStoreCypherQueryV2Connection",
            "kind": "LinkedField",
            "name": "cypherQueryV2",
            "plural": false,
            "selections": (v26/*: any*/)
          },
          {
            "alias": "jiraIssue",
            "args": [
              (v5/*: any*/),
              {
                "kind": "Variable",
                "name": "query",
                "variableName": "jiraIssueQuery"
              },
              (v6/*: any*/)
            ],
            "concreteType": "GraphStoreCypherQueryV2Connection",
            "kind": "LinkedField",
            "name": "cypherQueryV2",
            "plural": false,
            "selections": (v26/*: any*/)
          },
          {
            "alias": "pullRequest",
            "args": [
              (v5/*: any*/),
              {
                "kind": "Variable",
                "name": "query",
                "variableName": "pullRequestQuery"
              },
              (v6/*: any*/)
            ],
            "concreteType": "GraphStoreCypherQueryV2Connection",
            "kind": "LinkedField",
            "name": "cypherQueryV2",
            "plural": false,
            "selections": (v26/*: any*/)
          }
        ]
      }
    ]
  },
  "params": {
    "id": "1da2ae2f80c8177b5dcd3d56ab0591dd8cb49de78696c7ca562a6a372a6f3d88",
    "metadata": {},
    "name": "HomeAssignedListQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d7ee250ed9cef5ee2dd8942bbad595a4";

export default node;
